import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { useSnackbar } from "notistack";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { saveAs } from "file-saver";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import {
  CLIENT,
  FALSE,
  TRUE,
} from "../../../../../utility/constants/valueConstants";
import {
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { fullScreenLoadingSlice } from "../../../../../data/redux/slice/loaderSlice";
const DownloadCustomerList = ({ programId, serviceProviderType }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const clientList = useSelector((state) => state.dropDownListSlice.clientList);

  const [selectedClient, setSelectedClient] = useState({
    label: "Client Name",
    value: "",
  });
  const [vanNumber, setVanNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState("");
  const role = secureStorage.getItem(SS_ROLE);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };
  const statusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Active",
      value: "true",
    },
    {
      label: "In-Active",
      value: "false",
    },
  ];

  const downloadVanCustomerList = () => {
    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
    const role = secureStorage.getItem(SS_ROLE);
    if (
      (fromDate && toDate) ||
      selectedClient.value ||
      selectedStatus?.value ||
      vanNumber
    ) {
      setLoading(true);
      ApiRequestGet.downloadVanCustomerList({
        page: "",
        size: "",
        dateRange:
          fromDate && toDate
            ? moment(fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(toDate).format("DD/MM/YYYY")
            : "",
        keyWord: "",
        van: vanNumber ?? "",
        name: "",
        status: selectedStatus.value ?? "",
        clientHashId: selectedClient.value ?? "",
        programId: programId,
        serviceProviderType: serviceProviderType,
      })
        .then((res) => {
          saveAs(res, "customer.csv");
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      enqueueSnackbar("Please select a filter to download", {
        variant: "error",
      });
    }
  };
  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
      }}
      className="hide-scroll-bar"
    >
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          From
        </label>
        <CustomDatePicker value={fromDate} onChange={setFromDate} />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          To
        </label>
        <CustomDatePicker
          value={toDate}
          onChange={setToDate}
          minDate={fromDate}
          disabled={fromDate ? false : true}
        />
      </div>
      {role !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
          />
        </div>
      )}
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          VAN/UPI
        </label>
        <CustomInput
          inputcomponentStyles={{ ...inputStyle }}
          placeholder="VAN/UPI"
          validator=""
          type="input"
          inputStyles={{
            ...containerStyle,
          }}
          value={vanNumber}
          onChange={(data) => {
            setVanNumber(data);
          }}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
          Status
        </label>
        <CustomSelect
          placeholder={"Status"}
          options={statusOptions}
          value={selectedStatus}
          onChange={(data) => {
            setSelectedStatus(data);
          }}
        />
      </div>
      <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
        <CustomButton
          title="Download"
          backgroundColor="#38369C"
          styles={{ width: 150 }}
          disabled={false}
          onClick={() => {
            downloadVanCustomerList();
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};
export default DownloadCustomerList;
